import React, { useState, useEffect, useRef } from 'react';

const CustomDropdown = ({
  options,
  selectedOption,
  onChange,
  label,
  searchable,
  placeholder,
  disabled,
  mapSearchFlag,
  parentSelected,
  isLoading = false,
  noOptionsMessage = 'No options found',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen((prevState) => {
        const newState = !prevState;

        if (newState) {
          setSearchTerm('');
          setFilteredOptions(options);
        }

        return newState;
      });
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value ? e.target.value.toString().toLowerCase() : '';
    setSearchTerm(e.target.value);

    const filtered = options.filter((option) => {
      const optionName = option ? option.toString().toLowerCase() : '';
      return optionName.includes(term);
    });

    setFilteredOptions(filtered);
  };

  const handleSelectOption = (option) => {
    if (!disabled && !option?.disabled) {
      onChange(option === null ? null : option);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-container" onClick={toggleDropdown}>
        <div className="selected-option">
          {selectedOption ? selectedOption : placeholder || 'Select an option'}
        </div>
        <div className={`arrow ${isOpen ? 'open' : ''}`}>&#x25BC;</div>
      </div>

      {isOpen && (
        <div className="options-list">
          {searchable && (
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
              disabled={disabled || isLoading}
            />
          )}

          {isLoading ? (
            <div className="no-options">Loading...</div>
          ) : filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={
                  typeof option === 'string'
                    ? `${option}-${index}`
                    : option.id || option.value || option.name || index
                }
                className="option"
                onClick={() => handleSelectOption(option)}
              >
                {typeof option === 'string' ? option : option.name || option}
              </div>
            ))
          ) : mapSearchFlag && parentSelected ? (
            <>
              <div className="no-options custom-no-options">
                We couldn’t find that location. Here are other options you can explore.
              </div>

              {options.length > 0 && (
                <div className="all-options-list">
                  {options.map((option, index) => (
                    <div
                      key={
                        typeof option === 'string'
                          ? `${option}-${index}`
                          : option.id || option.value || option.name || index
                      }
                      className="option"
                      onClick={() => handleSelectOption(option)}
                    >
                      {typeof option === 'string' ? option : option.name || option}
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div className="no-options">
              {options.length === 0 ? noOptionsMessage : 'No options found'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
